/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:08:51
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-29 15:34:53
 * @FilePath: \crm-product\src\views\performanceCalculation\views\import_statement\product_price\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';

export default {
  extends: TablePage,
  components: {},
  name: 'transfer_detail_table',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'view') {
        this.formConfig = {
          ...val,
          row,
        };
        this.modalConfig.width = '70%';
        this.modalConfig.title = val.name;
        this.openModal();
      }
    },
  },
};
